import React from 'react';
import { useRouter } from 'next/router';
import { gql, useQuery } from '@apollo/client';

import OrganisationProfileTemplate from '@templates/OrganisationProfile';

import OrganisationDetails from '@organisms/organisations/OrganisationDetails';
import { initializeApollorWithQueries, addApolloState } from '@app/config/apollo';
import OrganisationSeo from '@app/components/molecules/SEO/Organisation';
// import { SEARCH_OPPORTUNITY } from '@app/apollo/queries';
import Footer from "../../../components/organisms/common/Footer"
import Spacer from '../../../components/atoms/Spacer'

const ORGANISATION_DETAILS_QUERY = gql`
  query getOrganisation($slug: String!) {
    organisation(slug: $slug) {
      ...organisationDetails
    }
  }
  ${OrganisationDetails.fragments.organisation}
`;

const OrganisationProfilePage = () => {
  const router = useRouter();
  const { slug } = router.query;

  const { 
    data: { organisation } = {}
  } = useQuery(ORGANISATION_DETAILS_QUERY, {
    variables: {
      slug,
    }
  });

  return (
    <>
      {organisation && <OrganisationSeo organisation={organisation} />}

      <OrganisationProfileTemplate
        background={organisation && organisation.cover && organisation.cover.path}
      >
        {organisation && (
          <OrganisationDetails
            organisationSlug={slug}
            organisation={organisation}
          />
        )}
        <Spacer height='3rem' />
        <Footer />
      </OrganisationProfileTemplate>
    </>
  );
};


export async function getServerSideProps(ctx) {
  const { slug } = ctx.query;


  const { 
    apolloClient, 
    data: [{organisation}] = [{}]
  } = await initializeApollorWithQueries(ctx, [
    {
      query: ORGANISATION_DETAILS_QUERY,
      variables: {
        slug,
      }
    }
  ]);

  return addApolloState(apolloClient, {
    props: {
      namespacesRequired: ['common', 'dashboard', 'wizard', 'applications'],
    },
    notFound: !organisation
  })
}

export default OrganisationProfilePage;
